<wfbhsearch-searchbox [useRouting]="false" [searchUrl]="searchUrl"></wfbhsearch-searchbox>